import { sync } from 'uid-safe'

export const uuid = () => sync(18)
